export const config = {
  NODE_ENV: process.env.NODE_ENV || "development",
  BACKEND_URL: process.env.REACT_APP_BACKEND || "https://main.d1lj2p81kgteoe.amplifyapp.com/", 
  LOCAL_BACKEND_URL: process.env.REACT_APP_LOCAL_BACKEND|| "http://localhost:3004/", 
};